import React, { useRef, forwardRef, useImperativeHandle, useCallback } from 'react';
import type { OrderParams } from '../../product';

function CreateOrder(props, ref: React.Ref<{ excuteOrder: (orderParams: OrderParams) => void }>) {
  // const { orderParams } = props;

  const formRef = useRef<HTMLFormElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const excuteOrder = useCallback((orderParams: OrderParams) => {
    const form = formRef.current;
    const input = inputRef.current;
    input.value = JSON.stringify(orderParams);
    form.submit();
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      excuteOrder,
    }),
    [excuteOrder],
  );

  // NOTE: 默认是在当前页完成页面跳转

  return (
    <form
      ref={formRef}
      action={
        process.env.NODE_ENV === 'development'
          ? 'https://mall-st.3jyx.cn/purchaser/trade/shopCreate'
          : '/purchaser/trade/shopCreate'
      }
      method="post"
      style={{ display: 'none' }}
    >
      <input ref={inputRef} name="data" hidden />
    </form>
  );
}

export default forwardRef(CreateOrder);
